import { IconButton, Tooltip } from "@mui/material";

import CloseFullscreenOutlinedIcon from "@mui/icons-material/CloseFullscreenOutlined";
import OpenInFullOutlinedIcon from "@mui/icons-material/OpenInFullOutlined";

export default function HeaderVisibleButton(props) {
	const handleToogleVisible = () => {
		const toggleMaxHeight = (block) => {
			if (block) block.style.maxHeight = props.fullVisible ? 0 : props.maxHeight;
		};
		props.headersRef.forEach(toggleMaxHeight);
		props.setHeaderFullVisible(!props.fullVisible);
	};

	return (
		<Tooltip>
			<IconButton
				size="small"
				onClick={() => {
					if (props.f_handleVisible) {
						props.f_handleVisible();
					} else {
						handleToogleVisible();
					}
				}}
			>
				{props.fullVisible === true ? <CloseFullscreenOutlinedIcon /> : <OpenInFullOutlinedIcon />}
			</IconButton>
		</Tooltip>
	);
}
